var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostsModalGreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 174,
    viewBox: "0 0 352 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_59344)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 174,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.469 55.1328C229.469 55.1328 236.87 125.887 226.361 159.546L107.103 160.677C107.103 160.677 134.261 103.006 131.013 58.941L229.469 55.1328Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23 58.9621L224.993 55.418C216.784 97.1779 206.523 135.437 190.757 164.275L92 167.814C107.335 132.663 119.217 96.5153 126.23 58.9621Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.236 58.9616L224.993 55.4229L220.905 75.0559L122.347 77.5282L126.236 58.9616Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.006 91.8235L203.254 89.0928C199.197 110.872 192.533 132.083 183.406 152.269L107.157 155.005C115.888 132.722 123.058 111.343 127.006 91.8235Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.098 97.0972C134.913 96.9668 133.718 97.2405 132.708 97.8741C131.698 98.5076 130.932 99.4638 130.534 100.587C129.596 103.162 130.841 106.114 132.984 107.11C135.99 108.511 140.353 105.861 140.525 102.419C140.552 101.147 140.119 99.9086 139.306 98.9308C138.492 97.9531 137.353 97.302 136.098 97.0972Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.716 104.018C152.003 102.3 154.061 100.183 156.775 100.032C160.788 99.806 162.016 104.121 166.293 104.573C171.814 105.16 174.087 98.4219 180.567 97.9694C183.007 97.8024 186.567 98.5081 191.199 102.569",
    fill: "#E9F3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.716 104.018C152.003 102.3 154.061 100.183 156.775 100.032C160.788 99.806 162.016 104.121 166.293 104.573C171.814 105.16 174.087 98.4219 180.567 97.9694C183.007 97.8024 186.567 98.5081 191.199 102.569",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.619 64.9891C211.619 64.9891 199.726 64.989 201.778 52.2666C203.83 39.5442 217.695 45.0813 217.161 52.1966",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.605 64.3324C186.605 64.3324 174.712 64.3323 176.764 51.6099C178.816 38.8875 192.68 44.4247 192.147 51.5453",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.255 65.4847C163.255 65.4847 151.363 65.4847 153.415 52.7622C155.467 40.0398 169.326 45.577 168.798 52.6977",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.872 66.3524C138.872 66.3524 126.979 66.3523 129.031 53.6299C131.083 40.9075 144.942 46.4446 144.415 53.5599",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.745 113.467C122.745 113.467 172.224 112.26 198.66 109.519L122.745 113.467Z",
    fill: "#E9F3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.745 113.467C122.745 113.467 172.224 112.26 198.66 109.519",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.757 128.704L136.179 139.245C137.542 140.177 139.145 140.696 140.796 140.74C142.447 140.784 144.075 140.351 145.486 139.493L165.038 127.643C166.699 126.633 168.654 126.217 170.583 126.462C172.511 126.708 174.3 127.601 175.655 128.995L183.196 136.767",
    fill: "#E9F3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.757 128.704L136.179 139.245C137.542 140.177 139.145 140.696 140.796 140.74C142.447 140.784 144.075 140.351 145.486 139.493L165.038 127.643C166.699 126.633 168.654 126.217 170.583 126.462C172.511 126.708 174.3 127.601 175.655 128.995L183.196 136.767",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 75.5491L57.5508 45.7331L69.1506 45.7303L58.552 75.4384L43.0002 75.5491Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2037 75.4702L80.5122 33.3679L92.9328 33.7557L81.7235 75.0447L65.2037 75.4702Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5299 74.5306L103.783 22.0814L116.448 23.7945L104.574 75.3875L88.5299 74.5306Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.312 96.9489C293.821 86.1885 282.801 81.1161 273.347 80.9223C262.999 80.7064 251.768 86.2707 247.049 97.162C241.985 108.838 246.001 122.993 256.444 130.227C268.808 138.794 285.333 134.292 293.688 124.273C299.228 117.605 302.494 106.96 298.312 96.9489Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.463 99.144L268.423 112.012L291.011 102.553L288.166 98.3941L271.138 105.602L266.507 96.7156L262.463 99.144Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.269 113.199L282.123 118.178L280.888 122.522L257.035 117.543L258.269 113.199Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.002 155.327C237.002 155.327 257.764 159.775 265.139 139.114",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8854 94.0972C27.8682 94.1857 33.7262 110.424 34.6649 113.767C36.1858 119.198 41.7489 135.413 37.6174 132.367C33.4859 129.321 30.319 124.261 27.3278 124.135C24.5725 124.015 23.8572 130.041 37.2153 152.87C39.3686 156.548 44.5781 158.394 49.9058 157.358L68.7521 153.698C72.9983 152.871 75.976 149.628 75.5041 146.342L74.1149 136.753C74.1149 136.753 72.2865 126.716 71.476 123.594C70.6655 120.473 69.8907 102.699 65.4689 102.418C63.8565 102.321 62.5704 103.938 62.7276 109.473C62.8593 114.158 63.158 118.914 63.158 118.914C63.158 118.914 58.1105 102.973 56.7049 98.3925C54.4532 91.1211 51.8784 89.8786 50.8689 92.7615C49.0619 97.9081 54.6964 119.455 54.6964 119.455C54.6964 119.455 46.736 98.5025 46.2969 96.7773C44.9467 91.4972 42.5725 90.9552 41.7343 91.145C35.7237 92.4908 45.3755 120.673 45.3755 120.673C45.3755 120.673 37.0445 94.0182 32.8854 94.0972Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8315 121.725C40.8315 121.725 53.2506 118.98 59.0778 119.293L40.8315 121.725Z",
    fill: "#EFE8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8315 121.725C40.8315 121.725 53.2506 118.98 59.0778 119.293",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3398 152.329C56.3398 152.329 52.1686 139.161 46.2872 138.058C40.4057 136.955 38.5542 132.741 38.5542 132.741",
    fill: "#EFE8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3398 152.329C56.3398 152.329 52.1686 139.161 46.2872 138.058C40.4057 136.955 38.5542 132.741 38.5542 132.741",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.649 101.373C72.649 101.373 81.9167 108.809 81.7363 119.135",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.654 86.0777C75.654 86.0777 94.3228 101.052 93.957 121.836",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2816 113.587C25.2816 113.587 18.6289 103.737 21.8782 93.9598",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8537 127.26C17.8537 127.26 4.45292 107.429 10.993 87.7406",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.833 68.0985L345.026 67.5566C346.493 63.366 346.354 58.7804 344.637 54.6859C342.92 50.5913 339.746 47.2785 335.729 45.3877C319.056 37.5315 286.36 23.2555 238.779 7.61747C234.05 6.0509 228.9 6.35491 224.388 8.46679C219.876 10.5787 216.344 14.3382 214.517 18.9732C214.441 19.1195 214.395 19.2876 214.333 19.4413C213.413 21.8514 212.98 24.4203 213.06 26.9989C213.14 29.5775 213.73 32.1144 214.798 34.463C215.865 36.8116 217.389 38.9251 219.279 40.6808C221.169 42.4364 223.389 43.7993 225.81 44.6907C234.062 47.738 244.867 51.7018 256.716 55.9997L256.801 68.8792L266.54 59.5543C285.449 66.3677 305.855 73.5776 322.299 79.0167C326.737 80.5014 331.58 80.1903 335.791 78.1498C340.003 76.1093 343.248 72.5015 344.833 68.0985Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.062 13.3051C230.267 11.5151 222.768 15.2991 220.539 22.2801C218.311 29.2611 222.282 36.7797 228.939 39.217C236.044 41.8166 244.403 38.0068 246.737 30.5468C249.072 23.0868 244.356 15.2224 237.062 13.3051Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.811 41.7504C259.638 39.7798 263.606 37.7975 267.822 39.1252C273.504 40.8868 274.005 46.9021 280.231 49.4512C288.144 52.688 294.256 45.7987 300.997 49.0062C306.333 51.5474 305.427 57.2678 310.851 59.9509C315.668 62.3359 321.853 60.5312 326.244 58.6917",
    fill: "#EFE8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.811 41.7504C259.638 39.7798 263.606 37.7975 267.822 39.1252C273.504 40.8868 274.005 46.9021 280.231 49.4512C288.144 52.688 294.256 45.7987 300.997 49.0062C306.333 51.5474 305.427 57.2678 310.851 59.9509C315.668 62.3359 321.853 60.5312 326.244 58.6917",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.726 36.558C240.392 35.0885 238.32 33.8827 237.142 32.8847C236.49 32.3625 235.981 31.6844 235.662 30.913C235.407 30.1757 235.406 29.3742 235.659 28.6363C235.912 27.8983 236.405 27.2662 237.058 26.8406C237.902 26.2439 238.53 25.3904 238.849 24.4074C239.049 23.8413 239.131 23.2401 239.09 22.641C239.048 22.042 238.884 21.4576 238.609 20.9242C238.333 20.3908 237.951 19.9196 237.486 19.5396C237.021 19.1596 236.483 18.8791 235.906 18.7151C234.77 18.483 233.588 18.6791 232.589 19.2661C231.589 19.853 230.842 20.789 230.492 21.8938C230.19 22.7936 230.172 23.7647 230.44 24.6751C230.604 25.2531 230.61 25.8646 230.456 26.4454C230.302 27.0261 229.995 27.5547 229.566 27.9757C228.708 28.7925 227.599 29.2968 226.42 29.4078C222.58 29.8667 220.871 31.3159 220.871 31.3159",
    fill: "#EFE8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.726 36.558C240.392 35.0885 238.32 33.8827 237.142 32.8847C236.49 32.3625 235.981 31.6844 235.662 30.913C235.407 30.1757 235.406 29.3742 235.659 28.6363C235.912 27.8983 236.405 27.2662 237.058 26.8406C237.902 26.2439 238.53 25.3904 238.849 24.4074C239.049 23.8413 239.131 23.2401 239.09 22.641C239.048 22.042 238.884 21.4576 238.609 20.9242C238.333 20.3908 237.951 19.9196 237.486 19.5396C237.021 19.1596 236.483 18.8791 235.906 18.7151C234.77 18.483 233.588 18.6791 232.589 19.2661C231.589 19.853 230.842 20.789 230.492 21.8938C230.19 22.7936 230.172 23.7647 230.44 24.6751C230.604 25.2531 230.61 25.8646 230.456 26.4454C230.302 27.0261 229.995 27.5547 229.566 27.9757C228.708 28.7925 227.599 29.2968 226.42 29.4078C222.58 29.8667 220.871 31.3159 220.871 31.3159",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_59344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 174,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsModalGreet);
export default __webpack_public_path__ + "static/media/postsModalGreet.80c343ab38c495f06748698e725a9fdd.svg";
export { ForwardRef as ReactComponent };